import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import HomeQapex from "components/Home/HomeQapex";
import CertificazioneQapex from "components/Home/CertificazioneQapex";
import ScrollToTop from "components/utils/ScrollToTop";
import { ResponsiveProvider } from "components/utils/Contexts/ResponsiveContext";
import { LanguageProvider } from "i18n/LanguageContext";
import { CookieConsentProvider } from "components/utils/CookieConsent";
import LegalPage from "components/Legal/LegalPage";
import WorkWithUs from "components/WorkWithUs/WorkWithUs";

// Componente per tracciare la view
function TrackPageView() {
  const location = useLocation();

  React.useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <CookieConsentProvider>
      <ResponsiveProvider>
        <div className="App" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>

          <TrackPageView />

          {/* Barra e footer sono dentro ogni pagina (components/Home/QapexChrome.js) */}
          <ScrollToTop />

          {/* Main Content */}
          <main style={{ flex: "1" }}>
            <Routes>
              <Route path="/" element={<HomeQapex />} />
              <Route path="/certificazione-qapex" element={<CertificazioneQapex />} />
              <Route path="/work-with-us" element={<WorkWithUs />} />
              <Route path="/privacy-policy" element={<LegalPage doc="privacy" />} />
              <Route path="/cookie-policy" element={<LegalPage doc="cookie" />} />
              {/* Le pagine tolte (contact, qaservice, qaconsulting, digital-services, questionario) e gli indirizzi sconosciuti portano alla home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </ResponsiveProvider>
      </CookieConsentProvider>
    </LanguageProvider>
  );
}

export default App;